import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	freeLabel: {
		id: 'navigation-apps-sidebar-edition-awareness.common.edition-awareness-label.free-label',
		defaultMessage: "You're on the Free plan",
		description: 'Label shown to users when they are on a free plan of Jira',
	},
	standardLabel: {
		id: 'navigation-apps-sidebar-edition-awareness.common.edition-awareness-label.standard-label',
		defaultMessage: "You're on a Standard trial",
		description: 'Label shown to users when they are on a standard plan of Jira',
	},
	premiumLabel: {
		id: 'navigation-apps-sidebar-edition-awareness.common.edition-awareness-label.premium-label',
		defaultMessage: "You're on a Premium trial",
		description: 'Label shown to users when they are on a premium plan of Jira',
	},
	gracePeriodStandardLabel: {
		id: 'navigation-apps-sidebar-edition-awareness.common.edition-awareness-label.grace-period-standard-label',
		defaultMessage: 'Your Standard trial is over',
		description:
			'Label shown to users when their standard plan finished and they are in grace period',
	},
	gracePeriodPremiumLabel: {
		id: 'navigation-apps-sidebar-edition-awareness.common.edition-awareness-label.grace-period-premium-label',
		defaultMessage: 'Your Premium trial is over',
		description:
			'Label shown to users when their premium plan finished and they are in grace period',
	},
});
